import {MOON_500, RED_500, THEME} from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

export const JobDrawerInner = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 20px;
`;
JobDrawerInner.displayName = 'S.JobDrawerInner';

export const JobDrawerInnerMain = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  padding-bottom: 8px;
`;
JobDrawerInnerMain.displayName = 'S.JobDrawerInnerMain';

export const StickyFooter = styled.div`
  margin-top: auto;
  position: sticky;
  bottom: 0;
  background: ${THEME.bgSurface};
`;
StickyFooter.displayName = 'S.StickyFooter';

export const HintText = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: light-dark(${MOON_500}, ${THEME.textTertiary});
  margin-top: 4px;
`;
HintText.displayName = 'S.HintText';

export const PriorityHints = styled.div`
  margin-top: 8px;
`;

PriorityHints.displayName = 'S.PriorityHints';

export const PriorityHint = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 26px;
  color: light-dark(${MOON_500}, ${THEME.textTertiary});
  & svg {
    margin-right: 4px;
  }
`;
PriorityHint.displayName = 'S.PriorityHint';

export const Error = styled.div`
  color: light-dark(${RED_500}, ${THEME.statusErrorText});
  font-size: 14px;
`;
Error.displayName = 'S.Error';

export const ToggleConfig = styled.div`
  display: flex;
  justify-content: flex-start;
  flex: 1 1 auto;
`;
ToggleConfig.displayName = 'S.ToggleConfig';

export const SuccessfulQueue = styled.div`
  display: flex;
  align-items: center;
`;
SuccessfulQueue.displayName = 'S.SuccessfulQueue';

export const SuccessfulQueueMessage = styled.div`
  margin-left: 8px;
`;
SuccessfulQueueMessage.displayName = 'S.SuccessfulQueueMessage';
